import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../../context/AuthProvider";
import { useUserConfig } from "../../context/UserConfigProvider";
import LoadingPage from "../LoadingPage";

const AuthenticatedBroadcasterOrModRoute = () => {
  const { isAuthenticated, user, isLoading: authLoading } = useAuth();
  const { permissions, loading: configLoading } = useUserConfig();
  const location = useLocation();

  if (authLoading || configLoading) {
    return <LoadingPage />;
  }

  if (!isAuthenticated || !user) {
    return <Navigate to="/login" replace />;
  }

  const { isBroadcaster } = user;
  const { isMod } = permissions;

  // Allow access if user is a broadcaster OR a mod
  if (!isBroadcaster && !isMod) {
    return <Navigate to="/home" replace state={{ from: location }} />;
  }

  return <Outlet />;
};

export default AuthenticatedBroadcasterOrModRoute;
